import { render } from "./TemplateDbsMyReport.vue?vue&type=template&id=48680774"
import script from "./TemplateDbsMyReport.vue?vue&type=script&lang=js"
export * from "./TemplateDbsMyReport.vue?vue&type=script&lang=js"

import "./TemplateDbsMyReport.vue?vue&type=style&index=0&id=48680774&lang=css"
script.render = render

export default script